import './specimen-search-screen.scss'

import { defineComponent } from 'vue';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'

import { SortFilter } from '@skinsoft/types';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { SearchHeader } from '@skinsoft/search/src/search-header';
import { SpecimenFeaturedList } from '@skinsoft/ui';

declare const config
const SPECIMEN_SORTING_ENTITY_FIELDS: SortFilter[] = config.specimensSortingEntityFields
const OFFLINE_SPECIMEN_SORTING_ENTITY_FIELDS: SortFilter[] = config.offlineSpecimensSortingEntityFields

export const SpecimenSearchScreen = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sSearchHeader: SearchHeader,
        sSpecimenFeaturedList: SpecimenFeaturedList,
    },
    props: ['targetRouteName', 'creationTargetRouteName', 'canCreateObject', 'displayedButtons', 'onlyNewSpecimens', 'titleClickAction'],
    template: require('./specimen-search-screen.html'),
    data() {
        return {
            sortingEntityFields: [] as SortFilter[],
            loadingSpecimenCreation: false,
            spinnerIcon: faCircleNotch
        }
    },
    mounted() {
        if(window.navigator.onLine) {
            this.sortingEntityFields = SPECIMEN_SORTING_ENTITY_FIELDS
        } else {
            this.sortingEntityFields = OFFLINE_SPECIMEN_SORTING_ENTITY_FIELDS
        }

        window.addEventListener('online', this.updateSortingFields)
        window.addEventListener('offline', this.updateSortingFields)
    },
    beforeUnmount() {
        window.removeEventListener('online', this.updateSortingFields)
        window.removeEventListener('offline', this.updateSortingFields)
    },
    methods: {
        updateSortingFields() {
            if(window.navigator.onLine) {
                this.sortingEntityFields = SPECIMEN_SORTING_ENTITY_FIELDS
            } else {
                this.sortingEntityFields = OFFLINE_SPECIMEN_SORTING_ENTITY_FIELDS
            }
        },
        createNewSpecimen() {
            this.loadingSpecimenCreation = true
            if (window.navigator.onLine) {
                this.$specimenDataStore.create({}, {}).subscribe(this.getToNewSpecimen)
            } else {
                const currentInstitution: string = localStorage.getItem('institution') as string
                this.$specimenDataStore.createOffline({
                    institutionCreation: currentInstitution
                }).subscribe(this.getToNewSpecimen)

            }
        },
        getToNewSpecimen(specimen: {id?: string }) {
            const path = this.creationTargetRouteName ? this.creationTargetRouteName : this.targetRouteName
            this.$router.push({name: path, params: {specimenId: specimen.id ?? ''}, query: {imageChoice: 'true'}})
        },
    },
})